import { request } from './http';

export async function getCompanyModules(companyId) {
    return request(`/companies/${companyId}/modules`);
  }

export async function getAllModules() {
    return request('/modules');
  }

export async function getCompanyModuleCodes(companyId) {
    return request(`/companies/${companyId}/module-codes`);
  }

export async function setCompanyModules(companyId, codes) {
    return request(`/customers/${companyId}/modules`, {
      method: 'PUT',
      body: JSON.stringify({ codes })
    });
  }

export const companyModuleManagementApi = {
  getCompanyModules,
  getAllModules,
  getCompanyModuleCodes,
  setCompanyModules,
};

